import { FormattedTipsAndTrick } from 'types/AlgoliaResults';
import { SearchResultCard, getRecipeImages } from '..';
import { PathTranslations } from 'service/localization/getPathTranslations';

export const mapAlgoliaTipsToSearchCard = (
  tip: FormattedTipsAndTrick,
  labels: Record<string, string>,
  pathTranslations: PathTranslations,
): SearchResultCard => ({
  resultType: 'tipsAndTricks',
  id: tip.id,
  title: tip.title,
  description: tip.description,
  category: tip.category,
  images: getRecipeImages(tip.images),
  link: {
    url: `${pathTranslations.tipAndTrick}${tip.slug}`,
    displayName: labels.see_details || 'See details',
  },
});
